// prettier-ignore
export default {
  "generic": {
    "network_error": "Impossibile connettersi.<br>Per favore, verifica la tua connessione Internet.",
    "network_restored": "La connessione a Internet è stata ripristinata.",
    "permisson_device_orientation_not_allowed": "Per utilizzare la funzione del sensore di direzione, ti consigliamo di riavviare il browser per richiedere nuovamente l'autorizzazione.<br>O assicurati che il tuo telefono sia verticalmente allineato al terreno prima di fare clic su Avanti.",
    "permisson_device_orientation_not_support": "Spiacenti, il tuo browser non supporta la funzione del sensore di direzione. Ti consigliamo di provare un altro browser o dispositivo.<br>O assicurati che il tuo telefono sia verticalmente allineato al terreno prima di fare clic su Avanti."
  },
  "login": {
    "cloudzet_welcome": "Ciao, benvenuto su Cloudzet",
    "mtm_username": "Account Scanatic™",
    "password": "password",
    "login": "Accedi",
    "logging_in": "Accesso in corso...",
    "no_login_methods": "Nessun metodo di accesso impostato per questo account Scanatic™",
    "agreements_button": "Accetta e continua",
    "complete_email_reset_pwd_title": "Sei in buone mani !",
    "sent_email": "Abbiamo inviato una email a",
    "email_reset_pwd": "Segui le instruzioni per resettare la password",
    "get_the_code": "Non hai ricevuto il codice?",
    "resend": "Rinvia",
    "complete_phone_reset_pwd_title": "Congratulazioni!",
    "login_new_password": "La nuova password è stata impostata,<br />effettua l'accesso con la nuova password",
    "login_my_account": "Accedi al mio account",
    "sent_a_code": "Abbiamo appena inviato un codice a",
    "received_code": "Fammi sapere se l'hai ricevuto",
    "verification_code_error": "Errore nel codice di verifica",
    "continue": "Continua",
    "forget_your_password": "Hai dimenticato la password?",
    "forget_password_text": "Niente paura!",
    "send": "Invia",
    "submit": "Invia",
    "no_such_user": "Account non trovato",
    "email_prompt_text": "Ti invieremo una email per reimpostare la password",
    "phone_prompt_text": "Ti invieremo un codice di verifica a 4 cifre",
    "login_title": "Bentornato!",
    "login_email_title": "Accedi con l'Email",
    "login_phone_title": "Accedi con il Telefono",
    "forget_password": "Hai dimenticato la password?",
    "terms_of_service": "I nostri termini di servizio",
    "choose_a_country_code": "Scegli un codice paese",
    "choose_a_country_code_hint": "L'accesso/la registrazione è disponibile solo nei seguenti paesi e regioni.",
    "country_code_not_found": "Impossibile trovare il tuo prefisso nazionale?",
    "sign_up_email": "Iscriviti con l'Email",
    "email_sign_up_error_msg": "Per favore, inserisci l'indirizzo email corretto",
    "four_characters": "La tua password deve essere lunga almeno 4 caratteri",
    "try_to_login": "Questo account esiste già. Prova ad effettuare l'accesso",
    "try_use_email": "Prova a usare la tua email",
    "sign_up": "Iscriviti",
    "sent_verification_code": "Ti invieremo un codice di verifica a 4 cifre.",
    "sign_up_phone": "Iscriviti con il Telefono",
    "sign_up_store": "Iscriviti con il negozio",
    "set_up_new_pwd": "Ora, imposta una nuova password",
    "set_up_new_password": "Ora puoi impostare<br> la tua nuova password",
    "set_new_pwd": "Imposta nuova password",
    "enter_country_code": "Inserisci il codice paese",
    "enter_email_address": "Inserisci il tuo indirizzo Email",
    "enter_phone_number": "Inserisci il tuo numero di telefono",
    "customer_account_name": "Nome Account Cliente",
    "enter_password": "Inserisci Password",
    "re_enter_password": "Reinserisci la password",
    "login_social_accounts": "Iscriviti con un account social",
    "social_login_failed": "Accesso con l'account social non riuscito",
    "login_first": "Effettua prima l'accesso",
    "create_with_store": "Crea con il negozio",
    "verify": "Verifica",
    "welcome_to_store": "Benvenuto in MyCamicia!",
    "login_to_continue": "Accedi/Registrati per continuare",
    "wrong_password": "Password errata. Inseriscila nuovamente.",
    "get_the_email": "Non hai ricevuto l'email?"
  },
  "welcome": {
    "enable_bt": "Password errata. Inseriscila nuovamente.",
    "powered_by": "Fornito da TG3D Studio Inc.",
    "tap_to_start": "Tocca la bolla per iniziare",
    "tap_camera_on": "Attiva la fotocamera per scannerizzare il codice QR",
    "ready_to_scan_qr": "Pronto per scannerizzare il codice QR",
    "note_front_camera": "Nota che la fotocamera frontale verrà utilizzata per scannerizzare il codice QR",
    "scan_code_title": "Scannerizza il codice QR per iniziare",
    "scan_code_hint": "Per favore, posiziona il codice QR nella casella",
    "scan_code_processing": "Elaborazione in corso...",
    "scan_code_logging_in": "Accesso al tuo account in corso...",
    "scan_code_connect_to_scanner": "Connessione allo scanner in corso...",
    "scan_code_no_account": "L'account non esiste. Riprova per favore.",
    "scan_code_done": "Pronto per iniziare!",
    "no_scanner_id": "Nessun ID scanner configurato per questo account Scanatic™",
    "no_scanner_found": "Scanner specificato non trovato",
    "scanner_in_use": "Lo scanner è in uso",
    "unexpected_error": "Qualcosa è andato storto :(",
    "need_camera_permission": "Devi concedere il permesso alla fotocamera per utilizzare questa funzionalità"
  },
  "choose": {
    "step_name": "Preparati per la scansione 3D del corpo",
    "step_info": "Quando sei pronto,<br>alza i pugni nelle bolle",
    "tutorial": "Tutorial",
    "start_scan": "Scansione 3D",
    "clench_fingers": "Stringi leggermente le dita",
    "raise_arm": "Alza il braccio finché tocchi la bolla",
    "hold_til_fill": "Ora tieni premuto finché la bolla si riempie"
  },
  "thingstonote": {
    "title": "Prima della scansione 3D del corpo",
    "wear_tight": "Indossa abiti aderenti e aderenti alla pelle",
    "tie_hair": "Raccogli i capelli per mostrare la parte posteriore del collo",
    "remove_acc": "Rimuovi tutti i tuoi accessori"
  },
  "scanscreen": {
    "skip": "salta"
  },
  "tutorial": {
    "title": "Il Tutorial del Controllo Senza Contatto",
    "contactless": "L'esperienza senza contatto garantisce la protezione della tua salute",
    "clench_fingers": "Stringi leggermente le dita",
    "raise_arm": "Per controllare le bolle, alza i braccia fino a toccare le bolle e mantieni la posizione per 2 secondi",
    "hold": "Ora tieni premuto finché la bolla si riempie",
    "proceed": "Per procedere al passo successivo, alza il braccio destro fino a toccare la bolla.",
    "return": "Per tornare al passo precedente, alza il braccio sinistro fino a toccare la bolla.",
    "feet_pos": "Posiziona i piedi sul tappetino da pavimento"
  },
  "scan": {
    "feet_pos": "Posiziona i piedi sul tappetino da pavimento",
    "step_name": "Scansione 3D del Corpo",
    "phase_one_done": "Fase 1 completata",
    "begin_2nd": "Inizia la scansione 3D del corpo nella seconda posa",
    "clench": "Stringi leggermente le dita",
    "raise_both_arm": "Alza lentamente i braccia e mantieni i pugni nelle bolle",
    "raise_fists": "Alza i pugni e mantienili nelle bolle",
    "lower_fists": "Abbassa i pugni e mantienili nelle bolle",
    "hold_still": "Mantieni i braccia immobili",
    "scan_keep_still": "Mantieni il corpo immobile",
    "scan_in_progress": "Scansione in corso",
    "scan_complete": "Scansione completata. <br>Puoi rilassare il corpo.",
    "two_step_scan": "La scansione verrà condotta in 2 fasi",
    "scanner_occupied": "La stanza di scansione è occupata. Si prega di contattare il personale per reimpostare lo scanner e riprovare.",
    "scanner_error_need_reset": "Errore dello scanner. Si prega di contattare il personale per reimpostare lo scanner e riprovare.",
    "scanner_error_generic": "Errore dello scanner. Si prega di contattare il personale.",
    "scanner_not_activated": "Lo scanner non è attivato. Si prega di contattare il personale.",
    "scanner_check_network": "Si prega di contattare il personale per verificare se lo scanner è connesso a Internet o per reimpostare lo scanner e riprovare."
  },
  "handles": {
    "hold": "Tieni le Maniglie.<br>Braccia Rilassate e Dritte",
    "hold_ready": "Tieni le Maniglie.<br>Adesso sei pronto",
    "letgo_and_keep_feet": "Lascia le maniglie e mantieni i piedi sulle impronte sul pavimento",
    "clench_ipose": "Pugni leggermente stretti, mani a circa 5 cm (2 pollici) dal corpo",
    "clench_ready": "Pugni leggermente stretti, Adesso sei pronto"
  },
  "end": {
    "thank": "Grazie!",
    "belonging": "Ti prego di ricordati di portare con te i tuoi effetti personali."
  },
  "analyzing": {
    "check_err": "Creazione del tuo Avatar 3D"
  },
  "result": {
    "scan_successful": "Ottimo lavoro!<br>La tua scansione 3D è stata effettuata con successo",
    "scan_unsuccessful": "Non siamo in grado di elaborare i tuoi dati",
    "avoid_errors": "Cause comuni di errori nella scansione",
    "error_accessories": "Indossare accessori",
    "error_cover_neck": "Capelli che coprono il collo",
    "error_floor_marks": "Piedi in posizione sbagliata",
    "error_postural": "Postura non corretta",
    "leave": "Esci",
    "raise": "Alza i pugni nelle bolle per effettuare una nuova scansione",
    "scan_again": "Scansiona di nuovo",
    "analyzing": "Elaborazione dei tuoi dati di scansione in corso...",
    "click_scan_again": "Fai clic sul pulsante qui sotto per scansionare nuovamente",
    "oops": "Ops!",
    "unexpected_error": "Qualcosa sembra non andare...",
    "close": "Chiudi",
    "error_top_loose": "Il tuo top è troppo largo",
    "error_bottoms_loose": "I tuoi pantaloni sono troppo larghi",
    "error_outfit_loose": "Il tuo abbigliamento è troppo largo",
    "scan_error_detected": "Rilevati problemi con la scansione"
  },
  "measurement": {
    "neck": "Collo",
    "chest": "Torace",
    "torso": "Torso",
    "mid_waist": "Vita \"Media\"",
    "hip": "Anca",
    "shoulder": "Spalla",
    "biceps": "Bicipite",
    "arm": "Braccio",
    "thigh": "Coscia",
    "inner_leg": "Gamba Int.",
    "chest_female": "Circ. Busto"
  },
  "homePage": {
    "firstScanTitle": "Inizia il tuo<br/>viaggio verso il futuro",
    "tap_to_scan": "Tocca per Effettuare la Scansione 3D",
    "measurement": "MISURAZIONE",
    "body_3d_avatar": "Corpo 3D",
    "see_more": "Vedi di più",
    "menu": "Menu",
    "store_settings": "Impostazioni del Negozio",
    "avatar_shader_3d": "Shader Avatar 3D",
    "avatar_shader": "Shader dell'avatar",
    "create_3d_shader": "Crea uno Shader 3D",
    "language": "Lingua",
    "get_help": "Ottenere aiuto",
    "feedback": "Feedback",
    "send_feedback": "Invia feedback",
    "send_btn": "Invia",
    "send_feedback_placeholder": "Il tuo feedback ci aiuterà a migliorare il nostro prodotto e servizio",
    "send_feedback_title": "Grazie per il tuo feedback",
    "send_feedback_content": "Prenderemo nota del tuo feedback e speriamo di offrire un'esperienza migliore in futuro. Non esitare a contattarci se hai altro da dire!",
    "report_crash": "Segnala un crash",
    "report_crash_title": "Grazie per avercelo segnalato",
    "report_crash_content": "Ci scusiamo per la tua esperienza. <br>Il nostro team esaminerà questo problema al più presto. Nel frattempo, non esitare a contattarci se riscontri altri problemi.",
    "rate_app": "Amo l'App Cloudzet",
    "rate_app_title": "Valuta l'App Cloudzet",
    "rate_app_content": "Se ami la nostra app, ti preghiamo di dedicare un momento per valutarla o recensirla sull'App Store. Grazie!",
    "login_s4f": "Accedi con l'account <br/> Scanatic™",
    "login": "Accedi con l'account <br/> Scanatic™",
    "password": "Password",
    "account_settings": "Impostazioni dell'account",
    "enter_Scanatic_account": "Inserisci l'account Scanatic™",
    "logout": "Esci",
    "delete_account": "Elimina account",
    "confirm_delete": "Sei sicuro?",
    "contactless_scan": "Scansione Senza Contatto",
    "delete": "Elimina",
    "cancel_delete": "Annulla",
    "ok": "Ok",
    "scan_to_login": "Scannerizza il codice QR",
    "go_to_app_store": "Vai all'App Store",
    "measure": "Misura",
    "history_tab": "Cronologia"
  },
  "settingUserData": {
    "your_birth": "Dimmi il tuo anno di nascita",
    "your_gender": "Dimmi il tuo genere",
    "female": "Femmina",
    "male": "Maschio",
    "tall": "Quanto sei alto?",
    "cm": "Cm",
    "inch": "Pollice",
    "your_height": "Altezza",
    "your_weight": "Quanto pesi?",
    "weight": "Peso",
    "lbs": "Libbre",
    "kg": "Chilogrammi",
    "nickname": "Il tuo nome",
    "lets_go": "Iniziamo"
  },
  "profile": {
    "profile": "Profilo",
    "edit_profile": "Modifica Profilo",
    "name": "Nome",
    "birthday": "Compleanno",
    "birthyear": "Anno di Nascita",
    "phone": "Numero di Telefono",
    "address": "Indirizzo",
    "save": "Ok"
  },
  "discovery": {
    "turn_on_bt": "Attiva il Bluetooth",
    "turn_on_bt_hint": "Autorizzare e abilitare il Bluetooth",
    "turn_on_bt_hint_ios": "Assicurati che le seguenti impostazioni siano completate:<br>1. Concedi l'autorizzazione<br>　● Vai su Impostazioni > Privacy e sicurezza > Bluetooth e abilita l'accesso per Cloudzet.<br>2. Attiva il Bluetooth<br>　● Vai su Impostazioni > Bluetooth e attivalo.",
    "turn_on_bt_hint_android": "Assicurati che le seguenti impostazioni siano completate:<br>1. Attivare il Bluetooth<br>　● Scorri verso il basso dalla parte superiore dello schermo, quindi tocca Bluetooth.",
    "searching": "Ricerca degli scanner nelle vicinanze...",
    "select_scanner": "Seleziona una stanza di scansione nelle vicinanze per iniziare",
    "scanner__foot": "Scanner per i Piedi",
    "scanner__body": "Scanner per il Corpo",
    "start_scan": "Avvia la Scansione 3D",
    "no_scanners": "Impossibile trovare scanner nelle vicinanze",
    "try_again": "Prova di nuovo",
    "scanner_is_busy_title": "Lo scanner è occupato",
    "scanner_is_busy_desc": "Per favore, controlla se c'è qualcuno dentro che sta usando lo scanner.",
    "scanner_is_busy_force_release": "Scansione ora",
    "scanner_is_busy_wait": "Attendere la scansione"
  },
  "mobileScan": {
    "mobile_scan": "Mobile Scan",
    "body_scanner": "Body Scanner",
    "data_processing": "Scan data processing...",
    "comeback_later": "Please come back in 5-10 minutes to review your 3D avatar",
    "data_process_failed": "Unable to process scan data",
    "error_not_inscreen": "Your entire body isn't captured in the screen",
    "error_messy_background": "The background is too messy",
    "device_unsupported": "Oops!<br>Your device doesn't support mobile phone 3D scan",
    "need_faceid": "The mobile 3D body scan can only be operated on iPhone X or newer iPhones with Face ID",
    "scanner_name": "Mobile 3D Body Scan",
    "confirm_info": "Please confirm your personal information",
    "begin_title": "Get Ready to Scan",
    "begin_info": "Indossa abiti aderenti e lega i capelli per mostrare la nuca",
    "start_tutorial": "Start tutorial",
    "not_first": "Not your first time here?",
    "skip_tutorial": "Skip tutorial",
    "vertical_info": "Place the phone<br>vertically on a<br>flat surface",
    "inscreen_info": "Make sure that<br>your entire body<br>is captured",
    "backoff_info": "Click next, go back<br>and get in scanning<br>pose in 10 sec.",
    "spin_info": "Clench your fingers,<br>open arms and rotate<br>in 360° within 10 sec.",
    "check_title": "Get Ready to Scan",
    "check_info": "Please confirm on the<br>following checklist",
    "wear_tight": "Wear skin-tight clothings and tie up your hair",
    "wipe_front": "Clean the front camera lens",
    "volume_up": "Turn the volume all the way up",
    "next": "Next",
    "start_scan": "Start Scan",
    "starting_in": "Starting in",
    "preview_info": "Please confirm on the<br>following checklist",
    "preview_inscreen": "Entire body is captured",
    "preview_arms_open": "Arms opened and fingers clenched",
    "preview_spin": "Rotate 360°",
    "preview_delete": "The video will be deleted once avatar is created",
    "rescan": "Scan again",
    "uploading": "Scan data processing...<br>Do not close the window",
    "uploading_done": "Analysis complete!<br>Please come back in 5-10 minutes to review your 3D avatar",
    "finish_btn": "Finish",
    "upload_error": "The mobile 3D body scan function isn't enabled<br>Please contact your selected store for more information",
    "no_balance": "The mobile 3D body scan function is suspended<br>Please contact your selected store for more information",
    "scan_limit_reached": "You have reached your scanning limits for this month<br>(each scan account is capped at 3 times per month)",
    "leave": "Leave",
    "no_credits": "Oops!\nYou don't have enough credits",
    "no_email": "Oops!\n You have to enter \nyour email address first",
    "credits": "Your Credits",
    "purchase": "Buy Credit",
    "purchase_cart": "My Cart",
    "purchase_total": "Total",
    "purchase_item": "Item",
    "purchase_checkout": "Checkout",
    "purchase_reminder": "We will send an invoice to your email address.",
    "payment_succeed": "Congratulations! \nYour order has been placed",
    "payment_succeed_des": "We will send an email\nto confirm your order details",
    "update_email": "Update Email",
    "front_info": "Per la foto frontale, mantieni la posa a A e resta fermo.",
    "side_info": "Per la foto di profilo, girati verso sinistra. Tieni le braccia vicine al corpo e resta fermo.",
    "qr_not_valid": "Codice QR non valido",
    "qr_not_valid_desc": "Contatta il negozio per un nuovo codice QR.",
    "back_to_home": "Torna alla home",
    "privacy_info": "Scansiona in tutta tranquillità: una volta creato il modello 3D, le foto vengono eliminate definitivamente."
  },
  "mobileScan2": {
    "inscreen_front_info": "Make sure your entire body is visible on the screen with arms and lets slightly apart",
    "inscreen_side_info": "For the side photo, Please turn left. Keep your feet together and place both hands against the outside of your thighs",
    "inscreen_info": "Assicurati che tutto il corpo sia visibile sullo schermo. Evita di inquadrare il bordo del tavolo.",
    "trun_left_info": "Turn left, place hands against the outside of thighs, keep feet together"
  },
  "share": {
    "voucher_expired": "Sessione scaduta.<br>Si prega di ricaricare la pagina.",
    "no_scan_data": "Nessun risultato di scansione trovato."
  }
};
